<template>
  <div id="login-partner-container" />
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import secureLs from '@/libs/secureLs'

export default {
  data() {
    return {
      email: '',
      password: '',
    }
  },
  mounted() {
    if (window === window.top) {
      const script = document.createElement('script')
      script.src = `${process.env.VUE_APP_BASE_AUTH_MODULE}/login-partner.js`
      script.async = true

      script.onerror = () => {
        const container = document.getElementById('login-partner-container')
        if (container) {
          container.innerHTML = `
            <div style="padding: 2rem; text-align: center; font-family: sans-serif; height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center; background-color: #f9fafb;">
              <h2 style="color: #ef4444; margin-bottom: 1rem;">Service Unavailable 🔌</h2>
              <p style="color: #374151; max-width: 500px; line-height: 1.5;">Halaman Login terpusat (SSO) gagal dimuat karena <b>partner-v2 (React)</b> tidak terdeteksi atau sedang mati.</p>
              <p style="color: #6b7280; font-size: 0.9rem; margin-top: 1rem; max-width: 500px;">Harap jalankan container/service partner-v2 di <code>${process.env.VUE_APP_BASE_AUTH_MODULE}</code> agar bisa login. Setelah partner-v2 menyala, silakan refresh halaman ini.</p>
            </div>
          `
        }
      }

      document.head.appendChild(script)
    } else {
      window.parent.postMessage({ type: 'REQUEST_SYNC_USER_DATA' }, '*')
    }

    // receive message from iframe
    return new Promise((resolve, reject) => {
      window.addEventListener(
        'message',
        async event => {
          const {
            type, data, access_token, menu, route, password, expires, access_account,
          } = event.data

          if (type === 'OPEN_LIVE_CHAT') {
            window.$crisp.push(['do', 'chat:open'])
          }

          if (type === 'REDIRECT_LOGIN') {
            this.$router.push('/login')
            return
          }

          if (type === 'login-complete') {
            this.email = data.email
            this.password = password

            useJwt.setToken(access_token, expires)
            resolve('OK')

            const role = data.role_name.toUpperCase()
            const komship = data.is_komship === 1
            const komstore = data.is_komstore === 1
            const kompack = data.is_kompack === 1
            const komcards = data.is_komcards === 1
            const komchat = data.is_komchat === 1
            const komads = data.is_komads === 1
            const komtim = data.is_komtim === 1
            const komed = data.is_komed === 1
            const isAnyInvoice = data.unpaid_invoice_exists

            let ability = []

            switch (role) {
              case 'PARTNER':
                if (komship) {
                  ability = [
                    { action: 'manage', subject: 'Komship TalentPool' },
                    { action: 'manage', subject: 'Komship Wishlist' },
                    { action: 'manage', subject: 'PartnerProfile' },
                    { action: 'read', subject: 'Dashboard Komship' },
                    { action: 'manage', subject: 'Customer' },
                    { action: 'manage', subject: 'Info Customer' },
                    { action: 'manage', subject: 'Data Customer' },
                    { action: 'manage', subject: 'Produk' },
                    { action: 'manage', subject: 'Tambah Produk' },
                    { action: 'manage', subject: 'Data Produk' },
                    { action: 'manage', subject: 'Order' },
                    { action: 'manage', subject: 'Tambah Order' },
                    { action: 'manage', subject: 'Data Order' },
                    { action: 'manage', subject: 'Pickup' },
                    { action: 'manage', subject: 'Ajukan Pickup' },
                    { action: 'manage', subject: 'History Pickup' },
                    { action: 'manage', subject: 'Keuangan' },
                    { action: 'manage', subject: 'Penghasilan' },
                    { action: 'manage', subject: 'Saldo' },
                    { action: 'manage', subject: 'Saldo Detail' },
                    { action: 'manage', subject: 'Setting Komship' },
                    { action: 'manage', subject: 'Setting Profile' },
                    { action: 'manage', subject: 'Setting Access Account' },
                    { action: 'manage', subject: 'Team' },
                    { action: 'manage', subject: 'Talent' },
                    { action: 'manage', subject: 'Setting Pickup Address' },
                    { action: 'manage', subject: 'Setting Rekening Bank' },
                    { action: 'manage', subject: 'Setting PIN' },
                    { action: 'manage', subject: 'Setting Ekspedisi' },
                    { action: 'manage', subject: 'Hiring' },
                    { action: 'manage', subject: 'Fitur Pendukung' },
                    { action: 'manage', subject: 'MyApps' },
                    { action: 'manage', subject: 'Kendala' },
                    { action: 'manage', subject: 'Tiket Kendala' },
                    { action: 'manage', subject: 'Monitoring Claim' },
                    { action: 'manage', subject: 'Inbox' },
                    { action: 'manage', subject: 'Insight' },
                  ]
                  if (kompack) {
                    ability.push({ action: 'manage', subject: 'Gudangku' })
                    ability.push({ action: 'manage', subject: 'Gudang' })
                    ability.push({ action: 'manage', subject: 'Cari Gudang' })
                    ability.push({ action: 'manage', subject: 'Ajukan Inbound' })
                    ability.push({
                      action: 'manage',
                      subject: 'Riwayat Pengajuan',
                    })
                    ability.push({ action: 'manage', subject: 'Tagihan' })
                    ability.push({ action: 'manage', subject: 'Kompack Partner Onboarding' })

                    if (this.isEligibleForKompackMarketplace(data.id)) {
                      ability.push({ action: 'manage', subject: 'Integrasi Marketplace' })
                      ability.push({ action: 'manage', subject: 'Marketplace Transaction' })
                    }
                  }
                  if (!kompack) {
                    ability.push({ action: 'manage', subject: 'Gudangku' })
                    ability.push({ action: 'manage', subject: 'Gudang' })
                  }
                  if (komstore) {
                    ability.push({ action: 'manage', subject: 'Komstore' })
                    ability.push({ action: 'manage', subject: 'Toko Online' })
                    ability.push({ action: 'manage', subject: 'Online Store' })
                    ability.push({ action: 'manage', subject: 'Komstore Partner Onboarding' })
                  }
                  if (komcards) {
                    ability.push({ action: 'manage', subject: 'KartuKomcards' })
                  }
                  if (isAnyInvoice) {
                    ability.push({ action: 'manage', subject: 'Invoice' })
                    ability.push({ action: 'manage', subject: 'Invoice Detail' })
                  }
                  if (data.total_sdm_assigned > 0) {
                    ability.push({ action: 'manage', subject: 'Presensi Talent' })
                  }
                }

                if (komstore) {
                  ability.push({ action: 'manage', subject: 'Komstore' })
                  ability.push({ action: 'manage', subject: 'Toko Online' })
                  ability.push({ action: 'manage', subject: 'Online Store' })
                  ability.push({ action: 'manage', subject: 'Komstore Partner Onboarding' })
                  ability.push({ action: 'read', subject: 'Dashboard Komship' })
                  ability.push({ action: 'manage', subject: 'Produk' })
                  ability.push({ action: 'manage', subject: 'Tambah Produk' })
                  ability.push({ action: 'manage', subject: 'Data Produk' })
                  ability.push({ action: 'manage', subject: 'Gudang' })
                  ability.push({ action: 'manage', subject: 'Gudangku' })
                  ability.push({ action: 'manage', subject: 'Keuangan' })
                  ability.push({ action: 'manage', subject: 'Saldo' })
                  ability.push({ action: 'manage', subject: 'Saldo Detail' })
                  ability.push({ action: 'manage', subject: 'Setting Komship' })
                  ability.push({ action: 'manage', subject: 'Setting Profile' })
                  ability.push({ action: 'manage', subject: 'Setting Payment' })
                  ability.push({ action: 'manage', subject: 'Setting Rekening Bank' })
                  ability.push({ action: 'manage', subject: 'Setting PIN' })
                  ability.push({ action: 'manage', subject: 'MyApps' })
                }

                if (kompack) {
                  // Gudang
                  ability.push({ action: 'manage', subject: 'Gudangku' })
                  ability.push({ action: 'manage', subject: 'Gudang' })
                  ability.push({ action: 'manage', subject: 'Cari Gudang' })
                  ability.push({ action: 'manage', subject: 'Ajukan Inbound' })
                  ability.push({ action: 'manage', subject: 'Riwayat Pengajuan' })

                  if (this.isEligibleForKompackMarketplace(data.id)) {
                    ability.push({ action: 'manage', subject: 'Integrasi Marketplace' })
                    ability.push({ action: 'manage', subject: 'Marketplace Transaction' })
                  }
                  // Produk
                  ability.push({ action: 'manage', subject: 'Produk' })
                  ability.push({ action: 'manage', subject: 'Tambah Produk' })
                  ability.push({ action: 'manage', subject: 'Data Produk' })
                  // Pickup
                  ability.push({ action: 'manage', subject: 'Pickup' })
                  ability.push({ action: 'manage', subject: 'Ajukan Pickup' })
                  ability.push({ action: 'manage', subject: 'History Pickup' })
                  // Keuangan
                  ability.push({ action: 'manage', subject: 'Keuangan' })
                  ability.push({ action: 'manage', subject: 'Saldo' })
                  ability.push({ action: 'manage', subject: 'Saldo Detail' })
                  // Pengaturan
                  ability.push({ action: 'manage', subject: 'Setting Komship' })
                  ability.push({ action: 'manage', subject: 'Setting Profile' })
                  // Team
                  ability.push({ action: 'manage', subject: 'Team' })
                  ability.push({ action: 'manage', subject: 'Talent' })
                  ability.push({ action: 'manage', subject: 'Setting Rekening Bank' })
                  ability.push({ action: 'manage', subject: 'Setting PIN' })
                  // Aplikasiku
                  ability.push({ action: 'manage', subject: 'MyApps' })
                  ability.push({ action: 'manage', subject: 'Tagihan' })
                  ability.push({ action: 'manage', subject: 'Kompack Partner Onboarding' })
                  if (isAnyInvoice) {
                    ability.push({ action: 'manage', subject: 'Invoice' })
                    ability.push({ action: 'manage', subject: 'Invoice Detail' })
                  }
                  if (data.total_sdm_assigned > 0) {
                    ability.push({ action: 'manage', subject: 'Presensi Talent' })
                  }
                }

                if (komcards) {
                  ability.push({ action: 'read', subject: 'Dashboard Komship' })
                  ability.push({ action: 'manage', subject: 'Keuangan' })
                  ability.push({ action: 'manage', subject: 'Setting Komship' })
                  ability.push({ action: 'manage', subject: 'Setting Profile' })
                  ability.push({ action: 'manage', subject: 'Setting Pickup Address' })
                  ability.push({ action: 'manage', subject: 'Setting Rekening Bank' })
                  ability.push({ action: 'manage', subject: 'Setting PIN' })
                  ability.push({ action: 'manage', subject: 'MyApps' })
                  ability.push({ action: 'manage', subject: 'Saldo Detail' })
                  ability.push({ action: 'manage', subject: 'KartuKomcards' })
                  // Team
                  ability.push({ action: 'manage', subject: 'Team' })
                  ability.push({ action: 'manage', subject: 'Talent' })
                  if (isAnyInvoice) {
                    ability.push({ action: 'manage', subject: 'Invoice' })
                    ability.push({ action: 'manage', subject: 'Invoice Detail' })
                  }
                  if (data.total_sdm_assigned > 0) {
                    ability.push({ action: 'manage', subject: 'Presensi Talent' })
                  }
                }

                if (komchat) {
                  ability.push({ action: 'manage', subject: 'Fitur Pendukung' })
                  ability.push({ action: 'manage', subject: 'Group Contact' })
                  ability.push({ action: 'manage', subject: 'Broadcast' })
                  ability.push({ action: 'manage', subject: 'Customer' })
                  ability.push({ action: 'manage', subject: 'Setting Profile' })
                  ability.push({ action: 'manage', subject: 'Setting Komship' })
                  ability.push({ action: 'manage', subject: 'MyApps' })
                  ability.push({ action: 'manage', subject: 'Keuangan' })
                  ability.push({ action: 'manage', subject: 'Saldo' })
                  ability.push({ action: 'manage', subject: 'Saldo Detail' })
                  ability.push({ action: 'manage', subject: 'Produk' })
                  ability.push({ action: 'manage', subject: 'Gudang' })
                  ability.push({ action: 'manage', subject: 'Inbox Komchat' })
                }

                // KOMADS
                if (komads) {
                  ability.push({ action: 'read', subject: 'Dashboard Komship' })
                  ability.push({ action: 'manage', subject: 'Marketing' })
                  ability.push({ action: 'manage', subject: 'Whitelisted Account' })
                  ability.push({ action: 'manage', subject: 'Saldo' })
                  ability.push({ action: 'manage', subject: 'Saldo Detail' })
                  ability.push({ action: 'manage', subject: 'Keuangan' })
                  ability.push({ action: 'manage', subject: 'Setting Komship' })
                  ability.push({ action: 'manage', subject: 'Setting Profile' })
                  ability.push({ action: 'manage', subject: 'Setting Rekening Bank' })
                  ability.push({ action: 'manage', subject: 'Setting PIN' })
                  ability.push({ action: 'manage', subject: 'MyApps' })
                }

                if (komtim) {
                  ability.push({ action: 'manage', subject: 'Komtim Partner Onboarding' })
                  ability.push({ action: 'manage', subject: 'Team' })
                  ability.push({ action: 'manage', subject: 'Talent' })
                  ability.push({ action: 'manage', subject: 'Keuangan' })
                  ability.push({ action: 'manage', subject: 'Saldo' })
                  ability.push({ action: 'manage', subject: 'Saldo Detail' })
                  ability.push({ action: 'manage', subject: 'Setting Komship' })
                  ability.push({ action: 'manage', subject: 'Setting Profile' })
                  ability.push({ action: 'manage', subject: 'Setting Rekening Bank' })
                  ability.push({ action: 'manage', subject: 'Setting PIN' })
                  ability.push({ action: 'manage', subject: 'MyApps' })
                  if (isAnyInvoice) {
                    ability.push({ action: 'manage', subject: 'Invoice' })
                    ability.push({ action: 'manage', subject: 'Invoice Detail' })
                  }
                  if (data.total_sdm_assigned > 0) {
                    ability.push({ action: 'manage', subject: 'Presensi Talent' })
                  }
                }

                if (komed) {
                  ability.push({ action: 'read', subject: 'Dashboard Komship' })
                  ability.push({ action: 'manage', subject: 'Konten' })
                  ability.push({ action: 'manage', subject: 'Buat Konten' })
                  ability.push({ action: 'manage', subject: 'Produk' })
                  ability.push({ action: 'manage', subject: 'Tambah Produk' })
                  ability.push({ action: 'manage', subject: 'Data Produk' })
                  ability.push({ action: 'manage', subject: 'MyApps' })
                  ability.push({ action: 'manage', subject: 'Setting Komship' })
                  ability.push({ action: 'manage', subject: 'Setting Profile' })
                  ability.push({ action: 'manage', subject: 'Setting Rekening Bank' })
                  ability.push({ action: 'manage', subject: 'Setting PIN' })
                }

                break
              default:
                break
            }
            if (role === 'TALENT GLOBAL') {
              // const menuAccess = menu.filter(
              //   item => item.access !== 'No Data Access.',
              // )
              access_account.forEach(item => {
                if (item.menu_name === 'PRODUK') {
                  ability.push({ action: 'manage', subject: 'Produk' })
                  const findAccessView = item.access.find(
                    accessItem => accessItem.access_id === 1,
                  )
                  const findAccessManage = item.access.find(
                    accessItem => accessItem.access_id === 2,
                  )
                  if (findAccessView !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Data Produk',
                      path: '/produk',
                    })
                  }
                  if (findAccessManage !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Tambah Produk',
                      path: '/add-produk',
                    })
                  }
                }
                if (item.menu_name === 'ORDER') {
                  ability.push({ action: 'manage', subject: 'Order' })
                  const findAccessView = item.access.find(
                    accessItem => accessItem.access_id === 1,
                  )
                  const findAccessManage = item.access.find(
                    accessItem => accessItem.access_id === 2,
                  )
                  if (findAccessView !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Data Order',
                      path: '/data-order',
                    })
                  }
                  if (findAccessManage !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Tambah Order',
                      path: '/add-order',
                    })
                  }
                }
                if (item.menu_name === 'DASHBOARD') {
                  const findAccessView = item.access.find(
                    accessItem => accessItem.access_id === 1,
                  )
                  if (findAccessView !== undefined) {
                    ability.push({
                      action: 'read',
                      subject: 'Dashboard Komship',
                      path: '/',
                    })
                  }
                }
                if (item.menu_name === 'GUDANG') {
                  // const findAccessView = item.access.find(accessItem => accessItem.access_id === 1)
                  const findAccessCariGudang = item.access.find(
                    accessItem => accessItem.access_id === 18,
                  )
                  const findAccessGudangku = item.access.find(
                    accessItem => accessItem.access_id === 16,
                  )
                  const findAccessAjukanInbound = item.access.find(
                    accessItem => accessItem.access_id === 17,
                  )
                  const findAccessRiwayatPengajuan = item.access.find(
                    accessItem => accessItem.access_id === 19,
                  )
                  ability.push({ action: 'manage', subject: 'Gudang' })
                  if (findAccessGudangku !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Gudangku',
                      path: '/gudangku',
                    })
                  }
                  if (findAccessCariGudang !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Cari Gudang',
                      path: '/cari-gudang',
                    })
                  }
                  if (findAccessAjukanInbound !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Ajukan Inbound',
                      path: '/ajukan-inbound',
                    })
                  }

                  if (this.isEligibleForKompackMarketplace(data?.id)) {
                    ability.push({ action: 'manage', subject: 'Integrasi Marketplace' })
                    ability.push({ action: 'manage', subject: 'Marketplace Transaction' })
                  }
                  if (findAccessRiwayatPengajuan !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Riwayat Pengajuan',
                      path: '/riwayat-pengajuan',
                    })
                  }
                }
                if (item.menu_name === 'PICKUP') {
                  ability.push({ action: 'manage', subject: 'Pickup' })
                  const findAccessView = item.access.find(
                    accessItem => accessItem.access_id === 6,
                  )
                  const findAccessManage = item.access.find(
                    accessItem => accessItem.access_id === 5,
                  )
                  if (findAccessView !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'History Pickup',
                      path: '/history-pickup',
                    })
                  }
                  if (findAccessManage !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Ajukan Pickup',
                      path: '/ajukan-pickup',
                    })
                  }
                }
                if (item.menu_name === 'KEUANGAN') {
                  ability.push({ action: 'manage', subject: 'Keuangan' })
                  const findAccessView = item.access.find(
                    accessItem => accessItem.access_id === 7,
                  )
                  const findAccessManage = item.access.find(
                    accessItem => accessItem.access_id === 8,
                  )
                  if (findAccessView !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Penghasilan',
                      path: '/keuangan/penghasilan',
                    })
                  }
                  if (findAccessManage !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Saldo',
                      path: '/keuangan/saldo',
                    })
                  }
                }
                if (item.menu_name === 'PENGATURAN') {
                  if (item.access !== null) {
                    ability.push({ action: 'manage', subject: 'Setting Komship' })
                    const findAccessBank = item.access.find(
                      accessItem => accessItem.access_id === 12,
                    )
                    const findAccessPin = item.access.find(
                      accessItem => accessItem.access_id === 13,
                    )
                    const findAccessExpedition = item.access.find(
                      accessItem => accessItem.access_id === 14,
                    )
                    if (findAccessBank !== undefined) {
                      ability.push({
                        action: 'manage',
                        subject: 'Setting Rekening Bank',
                        path: '/setting-kompship/rekening-bank',
                      })
                    }
                    if (findAccessPin !== undefined) {
                      ability.push({
                        action: 'manage',
                        subject: 'Setting PIN',
                        path: '/setting-kompship/pin',
                      })
                    }
                    if (findAccessExpedition !== undefined) {
                      ability.push({
                        action: 'manage',
                        subject: 'Setting Ekspedisi',
                        path: '/setting-kompship/ekspedisi',
                      })
                    }
                  }
                }
                if (item.menu_name === 'KENDALA') {
                  ability.push({ action: 'manage', subject: 'Kendala' })
                  const findAccessKendala = item.access.find(
                    accessItem => [1, 2, 3, 4].includes(accessItem.access_id),
                  )
                  const findAccessMonitoringClaim = item.access.find(
                    accessItem => accessItem.access_id === 22,
                  )
                  if (findAccessKendala !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Tiket Kendala',
                      path: '/ticketing',
                    })
                  }
                  if (findAccessMonitoringClaim !== undefined) {
                    ability.push({
                      action: 'manage',
                      subject: 'Monitoring Claim',
                      path: '/monitoring-claim',
                    })
                  }
                }
                if (item.menu_name === 'KARTU KOMCARDS') {
                  ability.push({ action: 'manage', subject: 'Keuangan', path: '/komcards' })
                  ability.push({ action: 'manage', subject: 'KartuKomcards', path: '/komcards' })
                }
              })
            }

            const path = ability.find(pathItem => pathItem.path !== undefined)
            if (path !== undefined) Object.assign(data, { path: path.path })

            data.ability = ability
            this.$ability.update(ability)

            secureLs.setItem('userData', JSON.stringify(data))
            localStorage.setItem('ability', JSON.stringify(ability))
            store.commit('auth/UPDATE_USER_DATA', data)

            const redirectUrl = getHomeRouteForLoggedInUser(role)
            window.location.href = redirectUrl
          }
        },
        false,
      )
    })
  },
  methods: {
    isEligibleForKompackMarketplace(userId) {
      const rawList = process.env.VUE_APP_KOMPACK_MARKETPLACE
      if (!rawList) return true

      const allowed = rawList
        .split(',')
        .map(v => String(v).trim())
        .filter(Boolean)

      return allowed.includes(String(userId).trim())
    },
  },
}
</script>
